import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EidosConfigService } from '@app/core/config/eidos-config.service';
import { IEidosModuleConfiguration } from '@app/core/config/environment.interface';
import { CoreBaseApiCommandParams } from '@app/core/models/core-base-api.model';
import { CoreModuleName } from '@app/core/models/core-constant.model';
import { DynamicApiResponse, DynamicApiResponsePaginatedModel } from '@app/core/models/dynamic-api-response.model';
import { CoreFormatService } from '@app/core/services/core-format.service';
import { EidosBaseApiService } from '@app/core/services/eidos-base-api.service';
import { EidosLogService } from '@app/core/services/eidos-log.service';
import { EidosSecurityService } from '@app/core/services/eidos-security.service';
import { IResApiManageServiceOptionFastCreateParams } from '@app/res-setup/models/resadm-experience.model';
import { GeoTreeDestination, IResApiGeoTreeParameters, ReservationApiGeotree } from '@app/res-setup/models/resadm-geo.model';
import { ReservationPickListPackage } from '@app/res-setup/models/resadm-package.model';
import { IReservationAPIGetHotelUnique, IReservationApiSupplier, ReservationHotelUnique, ReservationSupplier } from '@app/res-setup/models/resadm-service.models';
import { IResApiPeopleManageParameters, IResApiPeopleParameters, ResPeople } from '@app/reservation/models/people.model';
import { ResAirData } from '@app/reservation/models/res-air.model';
import { IReservationAirport, IReservationPriceSetup } from '@app/reservation/models/res-cached-data.models';
import { IReservationApiGetSanctuaryCampAllocations, ResPackageClearingCruise, ResPackageClearingNoCruise, ResPackageClearingVoyage, ResSanctuaryCampAgency, ResSanctuaryCampAllocation, ResSanctuaryCampSuiteCategory } from '@app/reservation/models/res-option.models';
import { IReservationApiGetPackageParams, IReservationApiItemAvailability, PackageHighlightType, ReservationPackageHighlightByType, ReservationPackageHighlightsType, ResItemAvailability, ResPackage, ResPackageSuiteConfig, ResPackageType } from '@app/reservation/models/res-package.model';
import { Circuit, CircuitLookupItem, CircuitType, ICircuitManage } from '@app/reservation/models/res-service.models';
import { LoadOptions } from 'devextreme/data';
import { ResolvedData } from 'devextreme/data/custom_store';
import { Observable, catchError, filter, lastValueFrom, map } from 'rxjs';
import { IRescomApiInvokeAIParams, RescomApiInvokeAI } from '../models/rescom-ai.model';
import { IResComApiGetServicesSearch, IReservationApiGetServices, IReservationApiService, IReservationApiServiceType, IReservationGeotreeCityPicklist, ISupplierDetailsAddress, ISupplierDetailsBankAccount, ISupplierDetailsContact, IRescomApiItinerary, RescomItinerary, ReservationServiceData, ReservationServiceOption, ReservationServiceType, ReservationSetupService, ReservationSetupServiceOption, SupplierAddressType, SupplierContactType, SupplierDetails, SupplierDetailsAddress, SupplierDetailsBankServiceAccount, SupplierDetailsContact, SupplierDetailsVendor, RescomItineraryDetails, ResSupplierContactList, ResSupplierUniqueContactList, IResApiGetServiceReport, IResApiGetServiceAudit, ReservationServiceAuditListItem, ReservationServiceOptionAuditListItem, ResContractItem, IResApiGetContractItems, IResApiManageContractItems, IResApiGetCommunicationItems, IResApiManageCommunicationItems, ResCommunicationItem, ResCommunicationItemType, ReservationConsortium, ResSrvAccAudit, IResApiGetOccupancyRules, ResOccupancyRule, IResApiGetOccupancyChildRules, ResOccupancyChildRule, IResApiGetServiceSetupFlightDetail, ResServiceSetupFlightDetail, IResApiManageServiceSetupFlightDetail, ResServiceDataAirports, ResServiceSetupServiceGroup, ResSupplierServiceCost, IResApiManageSupplierServiceCost, ResSupplierServicesInsertedData, ResServiceSetupOverrideDescription, IResApiManageServiceOverrideDescription, IResApiGetSetupServicesOptions, IResApiGetServiceNotes, ResServiceNote } from '../models/rescom-service.model';
import { IResAPIGetGeoTreeCountryAndContinent, IResApiAddAmenities, IResApiGetAmenities, IResApiGetCashReceiptTypes, IResApiGetPackageUpgradeInventory, IResApiGetPropertiesLight, IResApiGetRules, IResApiGetUniqueSuppliers, IResApiManageRule, IResApiManageSupplierUnique, IResApiManageSupplierUniqueAddresses, IResApiManageSupplierUniqueContacts, IResApiPackageAllocations, IResComApiGetPropertiesSearch, IReservationApiGetSuppliers, IReservationModuleAPIConfiguration, ResAdmAmenity, ResAdmAmenityTree, ResAdmRules, ResBkgProductType, ResCheckInDay, ResCompanyLight, ResContinent, ResGeoTree, ResGeoTreeCountryAndContinent, ResInvoiceLookup, ResLastWorkedBooking, ResPackageAllocation, ResPassportCountry, ResPkgBookingTravelDate, ResPriceSetupCurrencis, ResProperty, ResPropertyLight, ResPropertyLightSuiteCategory, ResReceiptType, ResRuleType, ResVillaAirConditioning, ResVillaDetails, ResVillaPriceRange, RescomUniqueSuppliers, RescomUpgradeInventory, ReservationSuiteAllocation, ReservationSuiteAllocationParams } from '../models/rescom.model';
import { IResApiGetDocumentationList, IResApiGetTopic, IResApiGetTopicSubjectList, ResAdmDocumentationList, ResAdmTopic, ResAdmTopicGuests, ResAdmTopicPreview, ResAdmTopicSubjectLookup } from '../models/rescom-topic.model';
import { IResApiGetSuggestedItems, IResApiManageAlternativeUpgradeSuggestedItem, IResApiManageSuggestedItems, IResApiUpdateAlternativeUpgradeSuggestedItem, IRescomApiGetExperiences, RescomExperience, ResSuggested, ResSuggestedBookingServices, ResSuggestedType } from '../models/res-suggested.model';

@Injectable({
  providedIn: 'root'
})
export class RescomApiService extends EidosBaseApiService {

  constructor(
    public configService: EidosConfigService,
    public eidosSecurityService: EidosSecurityService,
    public http: HttpClient,
    public eidosLogService: EidosLogService,
    public domSanitizer: DomSanitizer,
    public coreFormatService: CoreFormatService) {
    super(coreFormatService, configService, eidosLogService, eidosSecurityService, http);

    this.configService.currentModulesConfig
      .pipe(
        filter(
          (modules: Array<IEidosModuleConfiguration>) => !!modules.find((module) => module.moduleName === CoreModuleName.Reservation)
        )
      )
      .subscribe((modules) => {
        const module = modules.find((module) => module.moduleName === CoreModuleName.Reservation);

        if (module) {
          const reservationModuleAPI = module.API as IReservationModuleAPIConfiguration;
          this.urlAPI = reservationModuleAPI.url;
          this.staticUrlAPI = reservationModuleAPI.staticUrl;
          this.pluginUrlAPI = reservationModuleAPI.pluginUrl;
          this.apiVersion = reservationModuleAPI.version;
          if (reservationModuleAPI.headers) {
            this.headers = {
              ...reservationModuleAPI.headers,
              ...this.headers
            };
          }
        }
      });
  }

  private titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substring(1);
  }

  private localSort(items: [], loadOptions: any): [] {
    return items.sort((i1, i2) => {
      let field = loadOptions.sort[0].selector;
      let desc = loadOptions.sort[0].desc;
      let item1 = i1[field];
      if (!item1) {
        item1 = i1[this.titleCaseWord(field)];
      }
      let item2 = i2[field];
      if (!item2) {
        item2 = i2[this.titleCaseWord(field)];
      }
      if (item1 > item2) {
        return desc ? -1 : 1;
      }
      if (item1 < item2) {
        return desc ? 1 : -1;
      }
      return 0;
    });
  }

  private fillPaginatedParams(params?: any, loadOptions?: LoadOptions) {
    if (!params) params = {};

    if (!loadOptions) return params;

    const skip = loadOptions.skip ?? 0;
    const take = loadOptions.take ?? 20;

    params.PageNum = Math.floor(skip / take) + 1;
    params.PageSize = take;

    if (!!loadOptions.filter) {
      if (Array.isArray(loadOptions.filter[0])) {
        loadOptions.filter.forEach((f: any) => {
          if (Array.isArray(f)) {
            let field: string = f[0];
            let cmp: string = f[2];
            params[field] = cmp;
          }
        });
      } else {
        let field: string = loadOptions.filter[0];
        let cmp: string = loadOptions.filter[2];
        params[field] = cmp;
      }
    }

    if (!!loadOptions.sort) {
      const sort = loadOptions.sort as { selector: string; desc: boolean }[];

      params.OrderField = sort[0]?.selector;
      params.OrderDirect = sort[0]?.desc ? 1 : 0;
    }

    return params;
  }
  supplierCache:{ key: string,data:  Promise<ReservationSupplier[]> }[] = []
  getSuppliersMemoize(search?: string, id?: number) {
    const key = `${id}-${search}`
    const data = this.supplierCache.find(k=>k.key===key)?.data
    if(data) return data
    const newData = lastValueFrom(
                      this.getSuppliers({
                        SupplierID: (id === 0 ? undefined : id),
                        SupplierName: (search==='' ? undefined : search )
                      })
                    )
    this.supplierCache.push({
          key: key,
          data: newData
        })
    return newData
  }

  retriveWorkedBookingList(): Observable<ResLastWorkedBooking[]> {
    return this.callDynamicAPI('user/lastWorkedBooking', {}).pipe(
      map<DynamicApiResponse, ResLastWorkedBooking[]>((response) => response.body.map((s: any) => new ResLastWorkedBooking(s)))
    );
  }

  getSuppliers(params?: IReservationApiGetSuppliers): Observable<ReservationSupplier[]> {
    return this.callDynamicAPI('serviceSupplier/select', params).pipe(
      map<DynamicApiResponse, ReservationSupplier[]>((response) => response.body.map((s: any) => new ReservationSupplier(s)))
    );
  }

  getSuppliersPaginated(params?: IReservationApiGetSuppliers, loadOptions?: any): Promise<ResolvedData<ReservationSupplier>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('serviceSupplier/select', params).pipe(
        map<DynamicApiResponse, ResolvedData<ReservationSupplier>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((s: any) => new ReservationSupplier(s)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  getPackageHeader(params?: IReservationApiGetPackageParams): Observable<ResPackage[]> {
    return this.callDynamicAPI('packageHeader/select', params).pipe(
      map<DynamicApiResponse, ResPackage[]>((response) => response.body.map((s: any) => new ResPackage(s)))
    );
  }

  getPackageHeaderPaginated(params?: IReservationApiGetPackageParams, loadOptions?: any): Promise<ResolvedData<ResPackage>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('packageHeader/select', params).pipe(
        map<DynamicApiResponse, ResolvedData<ResPackage>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((o: any) => new ResPackage(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  getItemAvailability(params:IReservationApiItemAvailability) {
    return this.callDynamicAPI('item/availability', params, 'POST').pipe(
      map<DynamicApiResponse, ResItemAvailability[]>(
        (response: DynamicApiResponse) => response.body.map((o: any) => new ResItemAvailability(o)))
    )
  }

  getVilla(villaID: number): Observable<ResVillaDetails> {
    return this.getDynamicAPI('villa/getVilla', { VillaID: villaID }).pipe(
      map<DynamicApiResponse, ResVillaDetails>((response) => {
        return new ResVillaDetails(response.body)
      })
    );
  }

  public getService(params?: IResComApiGetServicesSearch): Observable<ReservationSetupService> {
    return this.callDynamicAPI('service/select', params).pipe(
      map<DynamicApiResponse, ReservationSetupService>((response) => {
        return new ReservationSetupService(response.body[0]);
      })
    );
  }

  public getServicesPaginated(params?: IResComApiGetServicesSearch, loadOptions?: any): Promise<ResolvedData<ReservationSetupService>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('service/select', params).pipe(
        map<DynamicApiResponse, ResolvedData<ReservationSetupService>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((o: any) => new ReservationSetupService(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  public getLinkedServiceOptions(serviceID: number): Observable<ReservationServiceOption[]> {
    return this.callDynamicAPI('service/getLinkedServices', { ServiceID: serviceID }).pipe(
			map<DynamicApiResponse, ReservationServiceOption[]>(response => {
				return response.body.map((o: any) => ({
					...o,
					serviceID: o.ServiceIDLnk,
          optionID: o.OptionID,
          cityID: o.CityID,
				}))
			})
		)
  }

  public manageService(params?: ReservationSetupService): Observable<any> {

    return this.postDynamicAPI('service/manage', params);
  }

  getItinerary(prms:IRescomApiItinerary): Observable<RescomItinerary[]> {
    return this.getDynamicAPI('product/itinerary', prms).pipe(
      map<DynamicApiResponse, RescomItinerary[]>(
        (response) => {
          const items:RescomItinerary[] = []
          const itineary = response.body.DT0 ?? []
          const details = response.body.DT1 ?? []
          itineary.forEach((item:any)=>{
            const itemItinerary = new RescomItinerary(item)
            itemItinerary.details = details.filter((det:any)=>
                                            det.ProductID===item.ProductID && det.Day===item.Day
                                           )
                                           .map((det:any)=> new RescomItineraryDetails(det))
            items.push(itemItinerary)
          })
          return items
        }
      ),
      catchError<any, RescomItinerary[]>((_: any) => [])
    );
  }
  public getServiceTypes(filters?: IReservationApiServiceType): Observable<ReservationServiceType[]> {
    return this.callDynamicAPI('serviceType/select', filters).pipe(
      map<DynamicApiResponse, ReservationServiceType[]>((response) => {
        return response.body.map((c: any) => new ReservationServiceType(c));
      })
    );
  }

  public getPicklistCitiesByID(id: number, departmentId = 1): Observable<IReservationGeotreeCityPicklist[]> {
    return this.callDynamicAPI('geotree/picklist', { GeoTreeID: id, departmentId: departmentId }).pipe(
      map<DynamicApiResponse, IReservationGeotreeCityPicklist[]>((response) => {
        return response.body
      })
    )
  }

  public getPicklistCities(city: string, departmentId = 1): Observable<IReservationGeotreeCityPicklist[]> {
    return this.callDynamicAPI('geotree/picklist', { GeoTreeName: city, DepartmentID: departmentId }).pipe(
      map<DynamicApiResponse, IReservationGeotreeCityPicklist[]>((response) => {
        return response.body
      })
    )
  }

  public getAirports(params: { AirportID?: number, AirName?: string }): Observable<Array<IReservationAirport>> {
    return this.callDynamicAPI('airport/select', params).pipe(
      map<DynamicApiResponse, Array<IReservationAirport>>((response) => {
        return response.body;
      })
    );
  }

  public getAirportsPaginated(params?: { AirportID?: number, AirName?: string }, loadOptions?: any): Promise<ResolvedData<IReservationAirport>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('airport/select', params).pipe(
        map<DynamicApiResponse, ResolvedData<IReservationAirport>>((response: DynamicApiResponse) => {
          return {
            data: response.body,
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  public getServices(params?: IReservationApiGetServices): Observable<ReservationServiceData[]> {
    return this.callDynamicAPI('service/select', params).pipe(
      map<DynamicApiResponse, Array<ReservationServiceData>>((response) => {
        return response.body.map((s: IReservationApiService) => new ReservationServiceData(s));
      })
    );
  }

  public getSetupServicesOptions(params: IResApiGetSetupServicesOptions): Observable<ReservationSetupServiceOption[]> {
    return this.callDynamicAPI('option/select', params).pipe(
      map<DynamicApiResponse, Array<ReservationSetupServiceOption>>((response) => {
        return response.body.map((o: any) => new ReservationSetupServiceOption(o));
      })
    );
  }

  public getServicesOptionsPaginated(params?: any, loadOptions?: any): Promise<ResolvedData<ReservationSetupServiceOption>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('option/select', params).pipe(
        map<DynamicApiResponse, ResolvedData<ReservationSetupServiceOption>>((response: DynamicApiResponse) => {
          return {
            data: this.localSort(response.body, loadOptions).map((o: any) => new ReservationSetupServiceOption(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading error';
    });
  }

  public manageSupplier(params?: IReservationApiSupplier): Observable<any> {
    return this.postDynamicAPI('serviceSupplier/manage', params).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body
      })
    )
  }

  public getSupplierDetails(supplierID: number): Observable<SupplierDetails> {
    return this.callDynamicAPI('supplier/getSupplierDetails', {SupplierID: supplierID}).pipe(
      map<DynamicApiResponse, SupplierDetails>((response) => {
        return new SupplierDetails(response.body);
      })
    );
  }

  public getAddressTypes(): Observable<SupplierAddressType[]> {
    return this.callDynamicAPI('supplier/getAddressTypes').pipe(
      map<DynamicApiResponse, SupplierAddressType[]>((response) => {
        return response.body.map((s: any) => new SupplierAddressType(s));
      })
    );
  }

  public getContactTypes(): Observable<SupplierContactType[]> {
    return this.callDynamicAPI('supplier/getContactTypes').pipe(
      map<DynamicApiResponse, SupplierContactType[]>((response) => {
        return response.body.map((s: any) => new SupplierContactType(s));
      })
    );
  }

  public getSupplierBankDetail(): Observable<SupplierDetailsBankServiceAccount[]> {
    return this.callDynamicAPI('supplier/getSupplierBankDetail').pipe(
      map<DynamicApiResponse, SupplierDetailsBankServiceAccount[]>((response) => {
        return response.body.map((s: any) => new SupplierDetailsBankServiceAccount(s));
      })
    );
  }

  public manageSupplierContacts(supplierID: number, supplierContacts?: ISupplierDetailsContact[]): Observable<any> {
    return this.postDynamicAPI('supplier/manageSupplierContact', {SupplierID: supplierID, SuppCont: supplierContacts}).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body
      })
    )
  }

  public manageSupplierAddresses(supplierID: number, supplierAddresses?: ISupplierDetailsAddress[]): Observable<any> {
    return this.postDynamicAPI('supplier/manageSupplierAddress', {SupplierID: supplierID, SupplierAddr: supplierAddresses}).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body
      })
    )
  }

  public manageSupplierBankDetail(supplierID: number, supplierBankDetail?: ISupplierDetailsBankAccount[]): Observable<any> {
    return this.postDynamicAPI('supplier/manageSupplierBankDetails', {SupplierID: supplierID, SuppBankDt: supplierBankDetail}).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body
      })
    )
  }

  public getCashReceiptTypes(params: IResApiGetCashReceiptTypes): Observable<ResReceiptType[]> {
    return this.callDynamicAPI('receiptType/select', params).pipe(
      map<DynamicApiResponse, ResReceiptType[]>((response) => {
        return response.body.map((s: any) => new ResReceiptType(s));
      })
    );
  }
  public getPackageBkgOnTravelDate(packageID: number, travelDateID: number): Observable<ResPkgBookingTravelDate[]> {
    return this.callDynamicAPI('package/BkgOnTravelDate', { PackageID: packageID, PackageTravelDateID: travelDateID}).pipe(
      map<DynamicApiResponse, ResPkgBookingTravelDate[]>((response) => {
        return response.body.map((s: any) => new ResPkgBookingTravelDate(s));
      })
    );
  }
  updatePackageBkgOnTravelDate(packageID: number, travelDateID: number): Observable<any> {
    return this.callDynamicAPI('package/updAllocBkg', { PackageID: packageID, PackageTravelDateID: travelDateID}).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body;
      })
    );
  }

  getPackageAllocationsPaginated(params?: IResApiPackageAllocations, loadOptions?: any): Promise<ResolvedData<ResPackageAllocation>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('package/getPackageAllocations', params).pipe(
        map<DynamicApiResponse, ResolvedData<ResPackageAllocation>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((o: any) => new ResPackageAllocation(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  getCheckInDay(): Observable<ResCheckInDay[]> {
    return this.callDynamicAPI('property/getCheckInDay').pipe(
      map<DynamicApiResponse, ResCheckInDay[]>((response) => {
        return response.body.map((s: any) => new ResCheckInDay(s));
      })
    );
  }

  getVillaPriceRange(): Observable<ResVillaPriceRange[]> {
    return this.callDynamicAPI('villa/getVillaPriceRange').pipe(
      map<DynamicApiResponse, ResVillaPriceRange[]>((response) => {
        return response.body.map((s: any) => new ResVillaPriceRange(s));
      })
    );
  }

  getVillaAirConditioning(): Observable<ResVillaAirConditioning[]> {
    return this.callDynamicAPI('villa/getVillaAirCond').pipe(
      map<DynamicApiResponse, ResVillaAirConditioning[]>((response) => {
        return response.body.map((s: any) => new ResVillaAirConditioning(s));
      })
    );
  }

  getSuiteVoyageAllocation(voyageID:number): Observable<ReservationSuiteAllocation[]> {
    return this.getSuiteAllocation( {
      voyageID:voyageID,
    });
  }
  getSuitePackageAllocation(
    packageID:number, packageTravelDateID: number
  ): Observable<ReservationSuiteAllocation[]> {
    return this.getSuiteAllocation( {
      packageID: packageID,
      packageTravelDateID: packageTravelDateID,
    });
  }

  getSuiteAllocation(filter: {
    packageID?:number,
    packageTravelDateID?: number,
    voyageID?: number
  }): Observable<ReservationSuiteAllocation[]> {
    return this.getDynamicAPI('suite/allocation', filter).pipe(
      map<DynamicApiResponse, ReservationSuiteAllocation[]>((response) => {
        const voyage = response.body.DT0 && response.body.DT0.length > 0 ?  response.body.DT0[0] : {}
        const suites =  response.body.DT1 && response.body.DT1.length > 0 ? response.body.DT1 : []
        return suites.map((s: any)=>new ReservationSuiteAllocation( Object.assign(s, voyage)) )
      })
    );
  }
  setSuiteAllocation(parameters: ReservationSuiteAllocationParams): Observable<boolean> {
    return this.postDynamicAPI('suite/setallocation', parameters).pipe(
      map<DynamicApiResponse, boolean>((_response) => {
        return true
      })
    );
  }

  getAllCompanies(): Observable<ResCompanyLight[]> {
    return this.callDynamicAPI('shorex/getAllCompanies').pipe(
      map<DynamicApiResponse, ResCompanyLight[]>((response) => {
        return response.body.map((s: any) => new ResCompanyLight(s));
      })
    );
  }

  getGeoCountryAndContinent(params?: IResAPIGetGeoTreeCountryAndContinent): Observable<ResGeoTreeCountryAndContinent[]> {
    return this.callDynamicAPI('geotree/getCountryAndContinent', params).pipe(
      map<DynamicApiResponse, ResGeoTreeCountryAndContinent[]>((response) => {
        return response.body.map((data: any) => new ResGeoTreeCountryAndContinent(data));
      })
    )
  }

  getGeoCountryAndContinentPaginated(params?: IResAPIGetGeoTreeCountryAndContinent, loadOptions?: any): Promise<ResolvedData<ResGeoTreeCountryAndContinent>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('geotree/getCountryAndContinent', params).pipe(
        map<DynamicApiResponse, ResolvedData<ResGeoTreeCountryAndContinent>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((o: any) => new ResGeoTreeCountryAndContinent(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  getTopicProductTypes(companiesID?: string): Observable<Array<ResBkgProductType>> {
    return this.callDynamicAPI('topic/getProductTypes', {CompaniesID: companiesID}).pipe(
      map<DynamicApiResponse, Array<ResBkgProductType>>((response) => {
        return response.body.map((data: any) => new ResBkgProductType(data));
      })
    )
  }

  getCountries(country?: string, countryCode?: string): Observable<ResPassportCountry[]> {
    return this.callDynamicAPI('country/select', {Country: country, CountryCod: countryCode}).pipe(
      map<DynamicApiResponse, ResPassportCountry[]>((response) => {
        return response.body.map((data: any) => new ResPassportCountry(data));
      })
    )
  }


  getGeoTree(countryCod?: string): Observable<ResGeoTree[]> {
    return this.callDynamicAPI('geotree/getGeoTree', {CountryCod: countryCod}).pipe(
      map<DynamicApiResponse, ResGeoTree[]>((response) => {
        return response.body.map((data: any) => new ResGeoTree(data));
      })
    )
  }

  getTopicPassportCountry(params?: {Country?: string, CountryCod?: string}): Observable<ResPassportCountry[]> {
    return this.callDynamicAPI('topic/getTopicCountry', params).pipe(
      map<DynamicApiResponse, ResPassportCountry[]>((response) => {
        return response.body.map((data: any) => new ResPassportCountry(data));
      })
    )
  }

  getContinent(): Observable<ResContinent[]> {
    return this.getDynamicAPI('pkg/getContinent').pipe(
      map<DynamicApiResponse, ResContinent[]>((response) => {
        return response.body.map((data: any) => new ResContinent(data))
      }))
  }

  getProperties(params?: IResComApiGetPropertiesSearch): Observable<ResProperty[]> {
    return this.getDynamicAPI('property/get', params).pipe(
      map<DynamicApiResponse, ResProperty[]>((response) => {
        return response.body.map((data: any) => new ResProperty(data))
      })
    )
  }

  getPropertiesPaginated(params?: IResComApiGetPropertiesSearch, loadOptions?: any): Promise<ResolvedData<ResProperty>> {
    params = this.fillPaginatedParams(params, loadOptions);

    return lastValueFrom(
      this.callDynamicAPI('property/get', params).pipe(
        map<DynamicApiResponse, ResolvedData<ResProperty>>((response: DynamicApiResponse) => {
          return {
            data: response.body.map((o: any) => new ResProperty(o)),
            totalCount: response.recordsCount,
          };
        })
      )
    ).catch(() => {
      throw 'Data loading errors';
    });
  }

  getAmenitiesTree(params?: IResApiAddAmenities): Observable<ResAdmAmenityTree[]> {
    return this.callDynamicAPI('villas/getAmenitiesTree', params).pipe(
      map<DynamicApiResponse, ResAdmAmenityTree[]>((response) => {
        const categories = response.body?.DT1 ?? []
        return response.body?.DT0.map((o: any) => new ResAdmAmenityTree(o, categories)) ?? []
      })
    )
  }

  getAmenityByTier(params: IResApiGetAmenities): Observable<ResAdmAmenity[]> {
    return this.callDynamicAPI('villas/getAmenities', params).pipe(
      map<DynamicApiResponse, ResAdmAmenity[]>((response) => {
        return response.body.map((o: any) => new ResAdmAmenity(o))
      })
    )
  }

  getVillaCategories(): Observable<any[]> {
    return this.callDynamicAPI('villa/getLookup', {Scope: 'StyleCategory'}).pipe(
      map<DynamicApiResponse, any[]>((response) => {
        return response.body
      })
    )
  }

  getVillaRegions(): Observable<any[]> {
    return this.callDynamicAPI('villa/getLookup', {Scope: 'Region'}).pipe(
      map<DynamicApiResponse, any[]>((response) => {
        return response.body
      })
    )
  }

  getAllCurrencies(): Observable<{currencyCod: string}[]> {
    return this.callDynamicAPI('apc/getAllCurrencies').pipe(
      map<DynamicApiResponse, {currencyCod: string}[]>((response) => {
        return response.body.map((o: any) => ({currencyCod: o.CurrencyCod}))
      })
    )
  }

  getServiceFacilities(): Observable<{Scope: string, Cod: string, Desc: string, Position: number}[]> {
    return this.callDynamicAPI('service/getFacilities').pipe(
      map<DynamicApiResponse, {Scope: string, Cod: string, Desc: string, Position: number}[]>((response) => {
        return response.body
      })
    );
  }

  invokeAI(params: IRescomApiInvokeAIParams): Observable<RescomApiInvokeAI> {

    const commandParams = new CoreBaseApiCommandParams({
      url: 'oem/ai/copywriter',
      data: params,
      type: 'POST',
      customBaseUrl: this.pluginUrlAPI
    });

    return this.sendCommand(commandParams).pipe(
      map<DynamicApiResponse, RescomApiInvokeAI>((response) => {
        return new RescomApiInvokeAI(response.body);
      }),
      catchError((err: HttpErrorResponse) => {
        throw err?.error?.Errors[0]?.ErrorDesc as string
      })
    );
  }

  invokeAIBulk(params: IRescomApiInvokeAIParams[]): Observable<RescomApiInvokeAI[]> {

    const commandParams = new CoreBaseApiCommandParams({
      url: 'oem/ai/copywriterbulk',
      data: params,
      type: 'POST',
      customBaseUrl: this.pluginUrlAPI
    });

    return this.sendCommand(commandParams).pipe(
      map<DynamicApiResponse, RescomApiInvokeAI[]>((response) => {
        return response.body.map((o: any) => new RescomApiInvokeAI(o));
      }),
      catchError((err: HttpErrorResponse) => {
        throw err?.error?.Errors[0]?.ErrorDesc as string
      })
    );
  }

  getPropertiesLight(params?: IResApiGetPropertiesLight): Observable<ResPropertyLight[]> {
    return this.callDynamicAPI('package/getPropertyLight', params).pipe(
      map<DynamicApiResponse, ResPropertyLight[]>((response) => {
        return response.body?.DT0?.map((o: any) => new ResPropertyLight(o))
      })
    )
  }

  getSinglePropertyLightWithSuiteCategory(params?: IResApiGetPropertiesLight): Observable<ResPropertyLight[]> {
    return this.callDynamicAPI('package/getPropertyLight', params).pipe(
      map<DynamicApiResponse, ResPropertyLight[]>((response) => {
        const property = response.body?.DT0 ?? []
        property[0].SuiteCategories = response.body?.DT1 ?? []
        return property.map((o: any) => new ResPropertyLight(o))
      })
    )
  }

  getPropertiesLightSuiteCategories(propertyID: number): Observable<ResPropertyLightSuiteCategory[]> {
    return this.callDynamicAPI('package/getPropertyLightSuiteCategories', { PropertyID: propertyID }).pipe(
      map<DynamicApiResponse, ResPropertyLightSuiteCategory[]>((response) => {
        return response.body.map((o: any) => new ResPropertyLightSuiteCategory(o))
      })
    )
  }

  getInvoiceGeneralScope(scope: string): Observable<ResInvoiceLookup[]> {
    return this.callDynamicAPI('payableCycle/getInvoiceGeneralScope', { Scope: scope }).pipe(
      map<DynamicApiResponse, ResInvoiceLookup[]>((response) =>
        (response.body ?? [])
          .map((item: any) => new ResInvoiceLookup(item))
          .filter((item: ResInvoiceLookup) => item.scope.toLowerCase() === scope.toLowerCase())
          .sort((a: ResInvoiceLookup, b: ResInvoiceLookup) => a.position - b.position)
      )
    );
  }

  getAllCurrenciesRes(): Observable<ResPriceSetupCurrencis[]> {
    return this.getDynamicAPI('priceSetup/getCurrencies').pipe(
      map<DynamicApiResponse, ResPriceSetupCurrencis[]>((response) => {
        return response.body.map((data: any) => new ResPriceSetupCurrencis(data))
      }))
  }

    //Experience/Service rules

    getRules(params: IResApiGetRules): Observable<ResAdmRules[]> {
      return this.callDynamicAPI('experience/getRules', params).pipe(
        map<DynamicApiResponse, ResAdmRules[]>((response) => {
          return response.body.map((data: any) => new ResAdmRules(data));
        })
      )
    }

    getRuleTypes(from: string): Observable<ResRuleType[]> {
      return this.callDynamicAPI('experience/getRuleTypes', {From: from }).pipe(
        map<DynamicApiResponse, ResRuleType[]>((response) => {
          return response.body.map((data: any) => new ResRuleType(data));
        })
      )
    }

    manageRule(params: IResApiManageRule) {
      return this.postDynamicAPI('experience/manageRules', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    //Supplier Unique
    getUniqueSuppliers(params?: IResApiGetUniqueSuppliers): Observable<RescomUniqueSuppliers[]> {
      return this.callDynamicAPI('supplier/getSupplierUnique', params).pipe(
        map<DynamicApiResponse, RescomUniqueSuppliers[]>((response) => {
          return response.body.map((data: any) => new RescomUniqueSuppliers(data));
        })
      )
    }

    manageSupplierUniqueGeneral(params?: IResApiManageSupplierUnique): Observable<any> {
      return this.postDynamicAPI('supplier/manageSupplierUnique', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getUniqueSupplierDetails(supplierUniqueID: number): Observable<{ addresses: SupplierDetailsAddress[]; contacts: SupplierDetailsContact[], vendors: SupplierDetailsVendor[]  }> {
      return this.callDynamicAPI('supplier/getSupplierUniqueDetails', { SupplierUniqueID: supplierUniqueID }).pipe(
        map<DynamicApiResponse, { addresses: SupplierDetailsAddress[]; contacts: SupplierDetailsContact[], vendors: SupplierDetailsVendor[] }>((response) => {
          return {
            addresses: response.body.DT0?.map((data: any) => new SupplierDetailsAddress(data)) ?? [],
            contacts: response.body.DT1?.map((data: any) => new SupplierDetailsContact(data)) ?? [],
            vendors: response.body.DT2?.map((data: any) => new SupplierDetailsVendor(data)) ?? [],
          }
        })
      )
    }

    manageSupplierUniqueAddresses(params?: IResApiManageSupplierUniqueAddresses) {
      return this.postDynamicAPI('supplier/manageSupplierUniqueAddress', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    manageSupplierUniqueContacts(params?: IResApiManageSupplierUniqueContacts) {
      return this.postDynamicAPI('supplier/manageSupplierUniqueContact', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getPackageUpgradeInventory(params?:IResApiGetPackageUpgradeInventory): Observable<RescomUpgradeInventory[]> {
      return this.callDynamicAPI('package/getInventoryUpgrade', params).pipe(
        map<DynamicApiResponse, RescomUpgradeInventory[]>((response) => {
          return response.body.map((data: any) => new RescomUpgradeInventory(data));
        })
      )
    }

    getTopicList(params?: IResApiGetTopic): Observable<ResAdmTopic[]> {
      return this.callDynamicAPI('topic/getTopicList', params).pipe(
        map<DynamicApiResponse, ResAdmTopic[]>((response) => {
          return response.body.map((o: any) => new ResAdmTopic(o))
        })
      )
    }

    getDocumentationListPaginated(params?: IResApiGetDocumentationList, loadOptions?: any): Promise<ResolvedData<ResAdmDocumentationList>> {
      params = this.fillPaginatedParams(params, loadOptions);

      return lastValueFrom(
        this.callDynamicAPI('topic/getDocumentationList', params).pipe(
          map<DynamicApiResponse, ResolvedData<ResAdmDocumentationList>>((response: DynamicApiResponse) => {
            return {
              data: response.body.map((o: any) => new ResAdmDocumentationList(o)),
              totalCount: response.recordsCount,
            };
          })
        )
      ).catch(() => {
        throw 'Data loading errors';
      });
    }

    getTopicSubjectListLookup(params?: IResApiGetTopicSubjectList): Observable<ResAdmTopicSubjectLookup[]> {
      return this.callDynamicAPI('topic/getTopicSubjectListLookup', params).pipe(
        map<DynamicApiResponse, ResAdmTopicSubjectLookup[]>((response) => {
          return response.body.map((o: any) => new ResAdmTopicSubjectLookup(o))
        })
      )
    }

    getTopicGuests(bkgID: number): Observable<ResAdmTopicGuests[]> {
      return this.callDynamicAPI('booking/getTopicGuestDayByDay', { BkgID: bkgID }).pipe(
        map<DynamicApiResponse, ResAdmTopicGuests[]>((response) => {
          return response.body.map((o: any) => new ResAdmTopicGuests(o))
        })
      )
    }

    getSupplierContactReport(supplierID?: number): Observable<ResSupplierContactList[]> {
      return this.callDynamicAPI('supplier/getSupplierContactReport', { SupplierID: supplierID }).pipe(
        map<DynamicApiResponse, ResSupplierContactList[]>((response) => {
          return response.body.map((s: any) => new ResSupplierContactList(s));
        })
      );
    }

    getSupplierUniqueContactReport(supplierUniqueID?: number): Observable<ResSupplierUniqueContactList[]> {
      return this.callDynamicAPI('supplierUnique/getSupplierUniqueReport', { SupplierUniqueID: supplierUniqueID }).pipe(
        map<DynamicApiResponse, ResSupplierUniqueContactList[]>((response) => {
          return response.body.map((s: any) => new ResSupplierUniqueContactList(s));
        })
      );
    }

    getServiceReport(params?: IResApiGetServiceReport, type: 'Service' | 'ServiceOptions' = 'Service'): Observable<any> {
      return this.callDynamicAPI(`service/get${type}Report`, params).pipe(
        map<DynamicApiResponse, any>((response) => response.body)
      );
    }
    getExcursionECMReport(params?: IResApiGetServiceReport): Observable<any> {
      return this.callDynamicAPI(`service/getExcursionECMReport`, params).pipe(
        map<DynamicApiResponse, any>((response) => response.body)
      );
    }

    getServiceAudit(params: IResApiGetServiceAudit): Observable<ReservationServiceAuditListItem[]> {
      return this.callDynamicAPI('service/getServiceAudit', params).pipe(
        map<DynamicApiResponse, ReservationServiceAuditListItem[]>((response) =>
          response.body.map((d: any) => new ReservationServiceAuditListItem(d))
        )
      );
    }

    getServiceOptionAudit(params: IResApiGetServiceAudit): Observable<ReservationServiceOptionAuditListItem[]> {
      return this.callDynamicAPI('service/getServiceOptionAudit', params).pipe(
        map<DynamicApiResponse, ReservationServiceOptionAuditListItem[]>((response) =>
          response.body.map((d: any) => new ReservationServiceOptionAuditListItem(d))
        )
      );
    }

    getContractItems(params?: IResApiGetContractItems): Observable<ResContractItem[]> {
      return this.callDynamicAPI('service/getContractItem', params).pipe(
        map<DynamicApiResponse, ResContractItem[]>((response) => response.body.map((c: any) => new ResContractItem(c)))
      );
    }

    manageContractItems(params?: IResApiManageContractItems) {
      return this.postDynamicAPI('service/manageContractItem', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getCommunicationItems(params?: IResApiGetCommunicationItems): Observable<ResCommunicationItem[]> {
      return this.callDynamicAPI('service/getCommunicationItem', params).pipe(
        map<DynamicApiResponse, ResCommunicationItem[]>((response) => response.body.map((c: any) => new ResCommunicationItem(c)))
      );
    }

    manageCommunicationItems(params?: IResApiManageCommunicationItems) {
      return this.postDynamicAPI('service/manageCommunicationItem', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getCommunicationTabs(): Observable<ResCommunicationItemType[]> {
      return this.callDynamicAPI('service/getCommunicationTabs', {}).pipe(
        map<DynamicApiResponse, ResCommunicationItemType[]>((response) => response.body.map((c: any) => new ResCommunicationItemType(c)))
      );
    }

    getConsortiums(agency?: string): Observable<ReservationConsortium[]> {
      return this.callDynamicAPI('service/getServiceConsortium', { Agency: agency }).pipe(
        map<DynamicApiResponse, ReservationConsortium[]>((response) =>
          response.body.map((data: any) => new ReservationConsortium(data))));
    }

    getSuggestedType(bkgID?: number): Observable<{ suggestedTypes: ResSuggestedType[], suggestedBookingServices: ResSuggestedBookingServices[] }> {
      return this.callDynamicAPI('setup/getSuggestedType', { BkgID: bkgID }).pipe(
        map<DynamicApiResponse, { suggestedTypes: ResSuggestedType[], suggestedBookingServices: ResSuggestedBookingServices[] }>((response) => {
          return {
            suggestedTypes: response.body.DT0?.map((data: any) => new ResSuggestedType(data)) ?? [],
            suggestedBookingServices: response.body.DT1?.map((data: any) => new ResSuggestedBookingServices(data)) ?? [],
          }
        })
      )
    }

    getSuggestedItems(params: IResApiGetSuggestedItems): Observable<ResSuggested[]> {
      return this.callDynamicAPI('setup/getSuggestedItems', params).pipe(
        map<DynamicApiResponse, ResSuggested[]>((response) =>
          response.body.map((data: any) => new ResSuggested(data))));
    }

    manageSuggestedItems(params?: IResApiManageSuggestedItems) {
      return this.postDynamicAPI('setup/manageSuggestedItem', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    manageAlternativeUpgradeSuggestedItem(params?: IResApiManageAlternativeUpgradeSuggestedItem) {
      return this.postDynamicAPI('booking/manageSuggestedBkgItems', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }
    updateAlternativeUpgradeSuggestedItem(params?: IResApiUpdateAlternativeUpgradeSuggestedItem) {
      return this.postDynamicAPI('booking/updateSuggestedBkgItems', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }
    getExperienceListCommonPaginated(params?: IRescomApiGetExperiences, loadOptions?: any): Promise<ResolvedData<RescomExperience>> {
      params = this.fillPaginatedParams(params, loadOptions);

      return lastValueFrom(
        this.callDynamicAPI('experience/getExperiences', params).pipe(
          map<DynamicApiResponse, ResolvedData<RescomExperience>>((response: DynamicApiResponse) => {
            return {
              data: response.body.map((o: any) => new RescomExperience(o)),
              totalCount: response.recordsCount,
            };
          })
        )
      ).catch(() => {
        throw 'Data loading errors';
      });
    }

    getSrvAccAudit(params: {serviceID:number}): Observable<ResSrvAccAudit[]> {
      const prms = {
        ServiceID: params.serviceID,
      }
      return this.getDynamicAPI('service/auditHtl', prms).pipe(
        map<DynamicApiResponse, ResSrvAccAudit[]>((response) => {
          let objResponse:any = response.body
          if(response.body.DT0) {
            objResponse = response.body.DT0
          }
          return objResponse.map((data: any) => {
            return new ResSrvAccAudit(data)
          })
        }))
    }

    getOccupancyRules(params?: IResApiGetOccupancyRules): Observable<ResOccupancyRule[]> {
      return this.callDynamicAPI('service/getOccupancyRules', params).pipe(
        map<DynamicApiResponse, ResOccupancyRule[]>((response) =>
          response.body.map((data: any) => new ResOccupancyRule(data))));
    }

    getTopicPreview(bkgID: number): Observable<ResAdmTopicPreview[]> {
      return this.callDynamicAPI('topic/getTopicPreview', { BkgID: bkgID }).pipe(
        map<DynamicApiResponse, ResAdmTopicPreview[]>((response) => {
          return response.body.map((o: any) => new ResAdmTopicPreview(o))
        })
      )
    }

    getOccupancyChildRules(params?: IResApiGetOccupancyChildRules): Observable<ResOccupancyChildRule[]> {
      return this.callDynamicAPI('service/getOccupancyRuleChild', params).pipe(
        map<DynamicApiResponse, ResOccupancyChildRule[]>((response) =>
          response.body.map((data: any) => new ResOccupancyChildRule(data))));
    }

    getFlightDetails(params?: IResApiGetServiceSetupFlightDetail): Observable<ResServiceSetupFlightDetail[]> {
      return this.callDynamicAPI('service/getServiceSetupFlightDetail', params).pipe(
        map<DynamicApiResponse, ResServiceSetupFlightDetail[]>((response) =>
          response.body.map((data: any) => new ResServiceSetupFlightDetail(data))));
    }

    manageFlightDetails(params?: IResApiManageServiceSetupFlightDetail) {
      return this.postDynamicAPI('service/manageServiceSetupFlightDetail', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getAvailablesAirports(): Observable<ResServiceDataAirports[]> {
      return this.callDynamicAPI('service/getAvailablesAirports').pipe(
        map<DynamicApiResponse, ResServiceDataAirports[]>((response) =>
          response.body.map((data: any) => new ResServiceDataAirports(data))));
    }

    confirmNestingGTY(bkgID: number | string): Observable<any> {
      return this.postDynamicAPI('inventory/confirmNestingGTY', { BkgID: bkgID }).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    refreshNestingGTY(params: {BkgID?: number | string; VoyageID?: string}): Observable<any> {
      return this.postDynamicAPI('inventory/refreshNesting', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getServiceGroups(): Observable<ResServiceSetupServiceGroup[]> {
      return this.callDynamicAPI('service/getServiceGroup', {}).pipe(
        map<DynamicApiResponse, ResServiceSetupServiceGroup[]>((response) => response.body.map((data: any) => new ResServiceSetupServiceGroup(data)))
      )
    }

    getSupplierServiceCost(supplierID: number): Observable<{ data: ResSupplierServiceCost[], serviceIDs: ResSupplierServicesInsertedData[] }> {
      return this.callDynamicAPI('supplier/getSupplierServiceCost', { SupplierID: supplierID }).pipe(
        map<DynamicApiResponse, { data: ResSupplierServiceCost[], serviceIDs: ResSupplierServicesInsertedData[] }>((response) => {
          return {
            data: response.body.DT0?.map((data: any) => new ResSupplierServiceCost(data)) ?? [],
            serviceIDs: response.body.DT1?.map((data: any) => new ResSupplierServicesInsertedData(data)) ?? [],
          }
        })
      );
    }

    manageSupplierServiceCost(params?: IResApiManageSupplierServiceCost) {
      return this.postDynamicAPI('supplier/manageSupplierServiceCost', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getOverrideDescription(serviceID: number): Observable<ResServiceSetupOverrideDescription[]> {
      return this.callDynamicAPI('service/getServiceOverrideDescription', { ServiceID: serviceID }).pipe(
        map<DynamicApiResponse, ResServiceSetupOverrideDescription[]>((response) =>
          response.body.map((data: any) => new ResServiceSetupOverrideDescription(data))));
    }

    manageOverrideDescription(params?: IResApiManageServiceOverrideDescription) {
      return this.postDynamicAPI('service/manageServiceOverrideDescription', params).pipe(
        map<DynamicApiResponse, any>((response) => {
          return response.body
        })
      )
    }

    getNotes(params: IResApiGetServiceNotes): Observable<ResServiceNote[]> {
      return this.callDynamicAPI('service/getNotes', params).pipe(
        map<DynamicApiResponse, ResServiceNote[]>((response) =>
          response.body.map((data: any) => new ResServiceNote(data))));
    }

  //#region Shared API moved from res-setup / reservation for DI decoupling

  getHotelUnique(params?: IReservationAPIGetHotelUnique): Observable<Array<ReservationHotelUnique>> {
    return this.callDynamicAPI('hotel/getUnique', params).pipe(
      map<DynamicApiResponse, Array<ReservationHotelUnique>>((response) => {
        return response.body.map((data: any) => new ReservationHotelUnique(data));
      })
    );
  }

  public getPackagePickList(search?: string, packageID?: number, packageTypeID?: number): Observable<ReservationPickListPackage[]> {
    return this.callDynamicAPI('package/search', { Search: search, PackageID: packageID, PackageTypeID: packageTypeID }, 'POST').pipe(
      map<DynamicApiResponse, ReservationPickListPackage[]>((response) => {
        return response.body.map((data: any) => new ReservationPickListPackage(data));
      })
    );
  }

  public geoTreeNavigate(filters: IResApiGeoTreeParameters, orderType: number = 0) {
    return this.callDynamicAPI(
      'geotree/navigate',
      { ...filters, OrderType: orderType },
      'POST'
    ).pipe(
      map<DynamicApiResponse, Array<GeoTreeDestination>>(
        (response) => {
          return response.body.map(
            (geo: any) => new GeoTreeDestination(geo)
          );
        })
    );
  }

  public geoTreeSearchNavigate(searched: string, orderType: number = 0, departmentID = 1) {
    return this.callDynamicAPI(
      'geotree/search',
      { Search: searched, OrderType: orderType, departmentID: departmentID },
      'POST'
    ).pipe(
      map<DynamicApiResponse, Array<GeoTreeDestination>>(
        (response) => {
          return response.body.map(
            (geo: any) => {
              const g = new GeoTreeDestination(geo);
              g.hightlightSearchText(searched);
              if (geo.Search === 1) {
                return g;
              } else {
                g.expanded = true;
                return g;
              }
            }
          );
        })
    );
  }

  public getGeoTreeItem(geoTreeID: number): Observable<ReservationApiGeotree> {
    return this.callDynamicAPI('geotree/itemGet', { GeoTreeID: geoTreeID }).pipe(
      map<DynamicApiResponse, ReservationApiGeotree>((response) => {
        return new ReservationApiGeotree(response.body);
      })
    );
  }

  manageServiceOptionFastCreate(params: IResApiManageServiceOptionFastCreateParams): Observable<any> {
    return this.postDynamicAPI('experience/manageServiceOptionFast', params).pipe(
      map<DynamicApiResponse, any>((response) => {
        return response.body;
      })
    );
  }

  getSupplierPackageList(params: { SupplierID: number }, loadOptions?: any): Observable<{ data: { packageID: number, packageName: string }[]; totalCount: number }> {
    params = this.fillPaginatedParams(params, loadOptions);
    return this.callDynamicAPI('package/getSupplierPackageList', params).pipe(
      map<DynamicApiResponse, { data: { packageID: number, packageName: string }[]; totalCount: number }>((response) => {
        return {
          data: response.body.map((data: any) => { return { packageID: data.PackageID, packageName: data.PackageName }; }),
          totalCount: response.recordsCount,
        };
      })
    );
  }

  public getPackages(params: IReservationApiGetPackageParams): Observable<ResPackage[]> {
    return this.callDynamicAPI('package/select', params).pipe(
      map<DynamicApiResponse, Array<ResPackage>>((response) => {
        return response.body.map((p: any) => new ResPackage(p));
      })
    );
  }

  getPackageVoyageSuites(packageID: number, packageTravelDateID: number): Observable<ResPackageSuiteConfig[]> {
    return this.getDynamicAPI('package/getPackageVoyageSuiteConfig', { PackageID: packageID, PackageTravelDateID: packageTravelDateID }).pipe(
      map<DynamicApiResponse, ResPackageSuiteConfig[]>((response) => {
        return response.body.map((data: any) => new ResPackageSuiteConfig(data));
      })
    );
  }

  getPackageTypeForSetup(): Observable<ResPackageType[]> {
    return this.getDynamicAPI('package/getPackageType').pipe(
      map<DynamicApiResponse, ResPackageType[]>((response) => {
        return response
          .body
          .map((data: any) => new ResPackageType(data))
          .filter((r: ResPackageType) => r.setup)
          .sort((pt: ResPackageType) => pt.order);
      }));
  }

  getPackageHighlightsType(): Observable<PackageHighlightType[]> {
    return this.getDynamicAPI('package/highlightsType').pipe(
      map<DynamicApiResponse, PackageHighlightType[]>((response) => {
        return response.body.map((data: any) => new PackageHighlightType(data));
      })
    );
  }

  getPackageHighlightsByPackageType(): Observable<ReservationPackageHighlightByType[]> {
    return this.callDynamicAPI('package/getPackageHighlightsByPackageType', { OrderField: 'PackageTypeID' }).pipe(
      map<DynamicApiResponse, any>((res) => res.body.map((el: any) => new ReservationPackageHighlightByType(el)))
    );
  }

  managePackageHighlightsByPackageType(params: { PackageHighlightsByPackageType: ReservationPackageHighlightByType[] }): Observable<any> {
    return this.postDynamicAPI('package/managePackageHighlightsByPackageType', params).pipe(
      map<DynamicApiResponse, any>((res) => res.body)
    );
  }

  getPackageHighlightsTypeList(params?: any, loadOptions?: any): Observable<{ data: ReservationPackageHighlightsType[]; totalCount: number }> {
    const filters = this.fillPaginatedParams(params, loadOptions);
    return this.callDynamicAPI('package/getPackageHighlightsTypeList', filters).pipe(
      map<DynamicApiResponse, { data: ReservationPackageHighlightsType[]; totalCount: number }>((response) => {
        return {
          data: response.body.map((data: any) => new ReservationPackageHighlightsType(data)),
          totalCount: response.recordsCount
        };
      })
    );
  }

  getScopeHighlightsList(): Observable<{ Scope: string }[]> {
    return this.callDynamicAPI('package/getScopeHighlightsList').pipe(
      map<DynamicApiResponse, { Scope: string }[]>((response) => response.body)
    );
  }

  managePackageHighlightsType(params: { PackageHighlightsType: ReservationPackageHighlightsType & { status: 'A' | 'D' } }): Observable<any> {
    return this.postDynamicAPI('package/managePackageHighlightsType', params).pipe(
      map<DynamicApiResponse, { data: ReservationPackageHighlightsType[]; totalCount: number }>((response) => response.body)
    );
  }

  getPackageClearing(params: { hasCruise: boolean, gty?: boolean }): Observable<ResPackageClearingCruise[] | ResPackageClearingNoCruise[]> {
    return this.getDynamicAPI('bkg/getPackageClearing', { HasCruise: params.hasCruise ? 'Y' : 'N', GTY: params.gty ? 'Y' : 'N' }).pipe(
      map<DynamicApiResponse, ResPackageClearingCruise[] | ResPackageClearingNoCruise[]>((response) => {
        return response.body.map((data: any) => params.hasCruise ? new ResPackageClearingCruise(data) : new ResPackageClearingNoCruise(data));
      })
    );
  }

  getPackageClearingByCompany(params: { companyID: number, gty?: boolean }): Observable<ResPackageClearingVoyage[]> {
    return this.getDynamicAPI('bkg/getPackageClearingByCompany', { Company: params.companyID, GTY: params.gty ? 'Y' : 'N' }).pipe(
      map<DynamicApiResponse, ResPackageClearingVoyage[]>((response) => {
        return response.body.map((data: any) => new ResPackageClearingVoyage(data));
      })
    );
  }

  getPackageClearingCompanyList(): Observable<{ companyID: number, endpoint?: string }[]> {
    return this.getDynamicAPI('bkg/getPackageClearingCompanyList').pipe(
      map<DynamicApiResponse, { companyID: number, endpoint?: string }[]>((response) => {
        return response.body.map((data: any) => { return { companyID: data.CompanyID, endpoint: data.Sp ?? undefined }; });
      })
    );
  }

  getSanctuaryCampAllocations(filters?: IReservationApiGetSanctuaryCampAllocations, loadOptions?: any): Observable<{ data: ResSanctuaryCampAllocation[]; totalCount: number }> {
    filters = this.fillPaginatedParams(filters, loadOptions);

    return this.callDynamicAPI('camp/getSanctuaryCampAllocations', filters, 'GET').pipe(
      map<DynamicApiResponse, { data: ResSanctuaryCampAllocation[]; totalCount: number }>((response) => {
        return {
          data: response.body.map((data: any) => new ResSanctuaryCampAllocation(data)),
          totalCount: response.recordsCount
        };
      }));
  }

  getSanctuaryCampAllocationsDownload(params: IReservationApiGetSanctuaryCampAllocations): Observable<ResSanctuaryCampAllocation[]> {
    return this.callDynamicAPI('camp/getSanctuaryCampAllocations', params).pipe(
      map<DynamicApiResponse, ResSanctuaryCampAllocation[]>((response) => response.body.map((data: any) => new ResSanctuaryCampAllocation(data))));
  }

  getSanctuaryCampSuiteCategoryFilters(params?: { PropertyID: number }): Observable<ResSanctuaryCampSuiteCategory[]> {
    return this.getDynamicAPI('camp/getSuiteCategoryFilters', params).pipe(
      map<DynamicApiResponse, ResSanctuaryCampSuiteCategory[]>((response) => response.body.map((data: any) => new ResSanctuaryCampSuiteCategory(data))));
  }

  getSanctuaryCampAgenciesFilters(params?: { Agency?: string }): Observable<ResSanctuaryCampAgency[]> {
    return this.getDynamicAPI('camp/getAgenciesFilters', params).pipe(
      map<DynamicApiResponse, ResSanctuaryCampAgency[]>((response) => response.body.map((data: any) => new ResSanctuaryCampAgency(data))));
  }

  getCircuits(filters?: { [key: string]: unknown }, loadOptions?: any): Observable<{ data: Circuit[]; totalCount: number }> {
    filters = this.fillPaginatedParams(filters, loadOptions);

    return this.callDynamicAPI('circuit/getCircuitList', filters, 'POST').pipe(
      map<DynamicApiResponse, { data: Circuit[]; totalCount: number }>((response) => {
        return {
          data: response.body?.map((data: any) => new Circuit(data)) ?? [],
          totalCount: response.recordsCount
        };
      }));
  }

  manageCircuit(params: Partial<ICircuitManage>): Observable<Circuit> {
    return this.callDynamicAPI('circuit/manageCircuit', params, 'POST').pipe(
      map<DynamicApiResponse, Circuit>((response) => {
        return response.body.map((data: any) => new Circuit(data))[0];
      }));
  }

  getCircuitDetail(circuitID: number): Observable<Circuit> {
    const params = { CircuitID: circuitID };

    return this.callDynamicAPI('circuit/getCircuitDetail', params, 'POST').pipe(
      map<DynamicApiResponse, Circuit>((response) => new Circuit(response.body)));
  }

  getCircuitType(): Observable<CircuitType[]> {
    return this.callDynamicAPI('circuit/getCircuitType').pipe(
      map<DynamicApiResponse, CircuitType[]>((response) => response.body?.map((data: any) => new CircuitType(data))));
  }

  getCircuitLookup(): Observable<CircuitLookupItem[]> {
    return this.callDynamicAPI('circuit/getCircuitLookup').pipe(
      map<DynamicApiResponse, CircuitLookupItem[]>((response) => response.body?.map((data: any) => new CircuitLookupItem(data))));
  }

  getPriceSetups(params?: Partial<{ PriceSetUpID: number, CostSetup: 'Y' | 'N', PageNum: number, PageSize: number }>): Observable<IReservationPriceSetup[]> {
    return this.callDynamicAPI('priceSetup/select', params, 'GET').pipe(
      map<DynamicApiResponse, IReservationPriceSetup[]>((response) => <IReservationPriceSetup[]>(response.body ?? [])));
  }

  peopleManage(filters: IResApiPeopleManageParameters) {
    return this.callDynamicAPI(
      'people/manage',
      filters,
      'POST'
    ).pipe(
      map<DynamicApiResponse, ResPeople>(response => new ResPeople(response.body[0]))
    );
  }

  getTourConsultantList(filters: IResApiPeopleParameters) {
    return this.callDynamicAPI(
      'people/getTourConsultantList',
      filters,
      'POST'
    ).pipe(
      map<DynamicApiResponse, { data: DynamicApiResponsePaginatedModel<ResPeople>, lookup: { SourceType: string }[] }>(
        (response) => {
          const paginatedModel = new DynamicApiResponsePaginatedModel<ResPeople>(response);
          paginatedModel.content = response.body?.DT0.map((people: any) => new ResPeople(people)) ?? [];
          return { data: paginatedModel, lookup: response.body?.DT1 ?? [] };
        })
    );
  }

  public getJwtToken() {
    return this.getExternalAPI('oem/dd/getJwtToken', 'GET', {}).pipe(
      map<any, any>((response) => {
        if (response.StatusCode != 200) throw new Error(response.ErrorMessage);

        return response.Token ?? '';
      })
    );
  }

  public getAirData(): Observable<ResAirData> {
    return this.getDynamicAPI('air/get', {}).pipe(
      map<DynamicApiResponse, ResAirData>((response) => {
        return new ResAirData(response.body);
      })
    );
  }

  private airDataPromise?: Promise<ResAirData>;
  private airDataCache?: ResAirData;

  async getAvailablesAirData(): Promise<ResAirData> {
    if (this.airDataCache) return this.airDataCache;
    if (!this.airDataPromise) {
      this.airDataPromise = lastValueFrom(this.getAirData()).then((airData) => {
        this.airDataCache = airData;
        return airData;
      });
    }
    return this.airDataPromise;
  }

  public getGeoPathData(req: {
    geoTreeID?: number;
    cityID?: number | undefined;
    serviceID?: number | undefined;
    hotelUniqueID?: number | undefined;
    experienceTemplateHdrID?: number;
    experienceID?: number;
    requestType?: string;
  }): Observable<any[]> {
    let payload: any;

    if (req.serviceID !== undefined) {
      payload = { ServiceID: req.serviceID, RequestType: req.requestType };
    } else if (req.experienceTemplateHdrID !== undefined) {
      payload = {
        ExperienceTemplateHdrID: req.experienceTemplateHdrID,
        ExperienceID: req.experienceID,
        RequestType: req.requestType
      };
    } else if (req.hotelUniqueID !== undefined) {
      payload = {
        HotelUniqueID: req.hotelUniqueID,
        RequestType: req.requestType
      };
    } else {
      payload = { GeoTreeID: req.geoTreeID, CityID: req.cityID, RequestType: req.requestType };
    }

    return this.callDynamicAPI('map/geopath', payload).pipe(
      map<DynamicApiResponse, any[]>((response) => {
        const body = Array.isArray(response.body) ? response.body : [];
        return body.map((d: any) => {
          const requestId = d.requestId ?? d.RequestId ?? d.RequestID ?? '';
          const baseUrl = d.url ?? d.Url ?? '';
          const requestType = req.requestType ?? '';
          let finalUrl: string;
          const sep = baseUrl.includes('?') ? '&' : '?';
          const parts: string[] = [];
          if (requestId) parts.push(`requestId=${encodeURIComponent(requestId)}`);
          if (requestType) parts.push(`type=${encodeURIComponent(requestType)}`);
          finalUrl = `${baseUrl}${sep}${parts.join('&')}`;
          return { requestId, url: baseUrl, finalUrl: encodeURIComponent(finalUrl) };
        });
      })
    );
  }

  //#endregion
}
